import { Tag, TagLabel, TagCloseButton, Box, Tooltip, TagProps } from '@chakra-ui/react';
import { ITag, TagType } from 'types';
import { getFormatDateFromStoreDate } from 'shared-components';
import VisaGapTagIcon from '../../../atoms/icons/visa-gap-tag-icon/index';

export const VisaGapTag = ({
  tag,
  canDelete,
  onClick,
  tagProps,
}: {
  tag: ITag;
  canDelete: boolean;
  onClick: any;
  tagProps?: TagProps;
}) => {
  const tagType = tag.type;
  return (
    <Tooltip
      hasArrow
      placement="bottom"
      label={<VisaGapInfo days={tag.visaGapExpiryDays} expiryDate={tag.visaGapExpiryDate} />}
    >
      <Tag
        size={'xs'}
        variant="solid"
        data-selector={`tag-visa-gap-${tagType === TagType.OVER_28_DAYS_VISA_GAP ? 'over-28-days' : 'under-28-days'}`}
        {...tagProps}
      >
        <Box mr="0.5">
          <VisaGapTagIcon />
        </Box>

        <TagLabel>{tag.label}</TagLabel>

        {canDelete && (
          <TagCloseButton
            onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              onClick();
            }}
          />
        )}
      </Tag>
    </Tooltip>
  );
};

const VisaGapInfo = ({ days, expiryDate }: { days?: number; expiryDate?: string }) => {
  return (
    <>
      <Box>Current UK visa expires {days} days before start date</Box>
      <Box>
        <b>Expiry {getFormatDateFromStoreDate(expiryDate)}</b>
      </Box>
    </>
  );
};
